import { Injectable } from '@angular/core';
import { SettingService } from './setting.service';
import { HttpClient, HttpParams } from '@angular/common/http';

@Injectable()
export class RegistrationPaymentService {

  constructor(
    private settings: SettingService,
    private http: HttpClient
  ) {}

  api = 'school-program-http/api/v1';

  getStudentPaymentData(activityId: any, filters?: { search?: string; is_paid?: boolean | null; payment_generated?: boolean | null; page?: number; page_size?: number }) {
    const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + '/register/' + activityId;
    // const requestUrl = 'http://localhost:3075/school-program-http/api/v1/register/' + activityId;

    let params = new HttpParams();
    if (filters) {
      if (filters.search) {
        params = params.set('search', filters.search);
      }
      if (filters.is_paid !== null && filters.is_paid !== undefined) {
        params = params.set('is_paid', String(filters.is_paid));
      }
      if (filters.payment_generated !== null && filters.payment_generated !== undefined) {
        params = params.set('payment_generated', String(filters.payment_generated));
      }
      if (filters.page !== undefined) {
        params = params.set('page', String(filters.page));
      }
      if (filters.page_size !== undefined) {
        params = params.set('page_size', String(filters.page_size));
      }
    }

    return this.http.get<any>(requestUrl, this.settings.httpOptionWithSession(params));
  }

  generatePaymentVa(params: any) {
    const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + '/generate-va';
    // const requestUrl = 'http://localhost:3075/school-program-http/api/v1/generate-va';

    return this.http.post<any>(requestUrl, params, this.settings.httpOptionWithSession());
  }

  getAccumulationPaymentSetup(params: any) {
    const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + '/payment-accumulation';
    // const requestUrl = 'http://localhost:3075/school-program-http/api/v1/payment-accumulation';

    return this.http.post<any>(requestUrl, params, this.settings.httpOptionWithSession());
  }

  saveAccumulationPaymentSetup(params: any) {
    const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + '/payment-accumulation';
    // const requestUrl = 'http://localhost:3075/school-program-http/api/v1/payment-accumulation';

    return this.http.patch<any>(requestUrl, params, this.settings.httpOptionWithSession());
  }

  generatePaymentVaByIpeka(params: any) {
    const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + '/generate-va-ipeka';
    // const requestUrl = 'http://localhost:3075/school-program-http/api/v1/generate-va-ipeka';

    return this.http.post<any>(requestUrl, params, this.settings.httpOptionWithSession());
  }

}
